import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/evaluation/evaluation/layouts/default.vue").then(m => m.default || m))
}